import * as Sentry from '@sentry/react';
import {
  getUserAttributes,
  setFullStoryIdentity,
  updatePendoInfo,
} from '../utils';
import mixpanel from '@8fig/mixpanel';

export async function identifyUser(signedIn: boolean = true) {
  try {
    const userAttributes = await getUserAttributes();
    const userId = userAttributes['cognito:username'];
    const email = userAttributes?.email;
    mixpanel.identify(email);
    mixpanel.people.set({ $last_login: new Date() });
    Sentry.setUser({ email });
    setFullStoryIdentity(userId, email);
    updatePendoInfo(userAttributes, signedIn);
  } catch (error) {}
}
